var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "new-tank-subscription-view" } },
    [
      _c("div", { staticClass: "row mb-3 justify-content-center" }, [
        _c(
          "p",
          {
            staticClass: "text-center plan-details-header",
            attrs: { "data-test-hook": "new-plan-with-upgrade-text" }
          },
          [_vm._v(" " + _vm._s(_vm.$t("xFuelMonitorRequiresPremium")) + " ")]
        )
      ]),
      _vm.selectedProduct
        ? _c(
            "b-card",
            {
              staticClass: "paid-subs-info-card mb-0 sub-card mx-1",
              attrs: {
                "body-class": "subs-info-card-body",
                "data-test-hook": "new-tank-subscription-modal-paid-card"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "plan-header",
                            attrs: {
                              "data-test-hook": "new-tank-subscription-header"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.selectedProduct.name) + " ")]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                1887645
              )
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c("CadenceSelectionTabs", {
                            attrs: {
                              "selected-product": _vm.selectedProduct,
                              "annual-paid-product": _vm.annualPaidProduct,
                              "monthly-paid-product": _vm.monthlyPaidProduct
                            },
                            on: { setSelectedProduct: _vm.setSelectedProduct }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    { staticClass: "mt-2 text-center justify-content-center" },
                    [
                      _c(
                        "h1",
                        { staticClass: "cost-label" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("formatCurrency")(
                                  _vm.selectedProduct.cost
                                )
                              )
                          ),
                          _c("span", { staticClass: "duration-label ml-1" }, [
                            _vm._v("/" + _vm._s(_vm.durationLabel))
                          ]),
                          _vm.annualPaidProduct &&
                          _vm.selectedProduct.productId ===
                            _vm.annualPaidProduct.productId
                            ? _c(
                                "b-badge",
                                {
                                  staticClass:
                                    "savings-badge ml-2 align-middle",
                                  attrs: {
                                    variant: "primary",
                                    "data-test-hook":
                                      "subscription-savings-badge"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("xSavePercent")))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c("b-row", { staticClass: "mt-2" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.selectedProduct.description))
                    ]),
                    _c("p", { staticClass: "mt-3" }, [
                      _c(
                        "strong",
                        {
                          attrs: {
                            "data-test-hook":
                              "new-tank-subscription-modal-included-features-text"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("xFeaturesIncluded")))]
                      )
                    ])
                  ]),
                  _c("b-row", { staticClass: "feature-list" }, [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-gas-pump fa-fw pr-4",
                        attrs: {
                          "data-test-hook":
                            "new-tank-subscription-modal-fuel-monitor-feature-icon-1"
                        }
                      }),
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-title-1"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.$t("xCurrentFuelLevel")))
                            ])
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "supporting-text",
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-description-1"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xFuelLevelDescription")) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-chart-line fa-fw pr-4",
                        attrs: {
                          "data-test-hook":
                            "new-tank-subscription-modal-fuel-monitor-feature-icon-2"
                        }
                      }),
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-title-2"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(" " + _vm._s(_vm.$t("xFuelUsageHistory")))
                            ])
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "supporting-text",
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-description-2"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xFuelUsageDescription")) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-warning fa-fw pr-4",
                        attrs: {
                          "data-test-hook":
                            "new-tank-subscription-modal-fuel-monitor-feature-icon-3"
                        }
                      }),
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-title-3"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(" " + _vm._s(_vm.$t("xFuelLevelWarnings")))
                            ])
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "supporting-text",
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-description-3"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xFuelLevelWarningsDescription")
                                ) +
                                " "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-battery-full fa-fw pr-4",
                        attrs: {
                          "data-test-hook":
                            "new-tank-subscription-modal-fuel-monitor-feature-icon-4"
                        }
                      }),
                      _c("div", [
                        _c(
                          "p",
                          {
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-title-4"
                            }
                          },
                          [
                            _c("strong", [
                              _vm._v(" " + _vm._s(_vm.$t("xBatteryLevel")))
                            ])
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass: "supporting-text",
                            attrs: {
                              "data-test-hook":
                                "new-tank-subscription-modal-fuel-monitor-feature-description-4"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xBatteryLevelDescription")) +
                                " "
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "b-row",
        { staticClass: "mt-3", attrs: { "no-gutters": "" } },
        [
          _c(
            "b-col",
            { staticClass: "float-left pl-2", attrs: { cols: "12" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "w-100",
                  attrs: {
                    variant: "warning",
                    disabled: _vm.isCreatingPurchaseIntent,
                    "data-test-hook":
                      "new-tank-subscription-modal-confirm-plan-button"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("openPayment")
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                  _vm.isCreatingPurchaseIntent
                    ? _c("b-spinner", { staticClass: "ml-2" })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }